<template>
  <div class="alert alert-info">
    <icon name="trash" width="20" height="20" />
    <slot />

    <button class="btn btn-success" tabindex="-1" type="button" @click="$emit('restore')">Restore</button>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  emits: ['restore'],
}
</script>
